export function getDayOfWeek(date: string | Date): string {
    if(!date){
        return '';
    }
    const daysOfWeek: string[] = [
        'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
    ];

    // Create a Date object from the given date
    const dateObj = new Date(date);

    // Get the day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    const dayOfWeek = dateObj.getUTCDay();

    return daysOfWeek[dayOfWeek];
};

// function to return the date after 30 days
export function addDaysToDate(date: string | Date, days: number): string {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate.toISOString().split('T')[0];
}